"use client";

import { CurrencySelector } from "@/components/features/currency";
import { NotificationDropdown } from "@/components/features/notifications";
import { ProfileWalletData } from "@/components/features/profile";
import { ClaimRewards } from "@/components/features/rewards/Reward/ClaimRewards";
import { WalletButton } from "@/components/features/wallet/WalletButton";
import { SkeletonElement } from "@/components/ui/skeleton";
import { useHubUser } from "@/hooks/user/useHubUser";

export const WalletSectionWeb = () => {
  const { authenticated, ready, isLoadingHubUser, hubUser } = useHubUser();

  // Show skeleton while auth provider initializes or while user data is loading after authentication
  // This prevents the "Connect wallet" prompt from flashing before showing the profile
  const isInitializing = !ready || (authenticated && isLoadingHubUser && !hubUser?.defiAddress);

  if (isInitializing) {
    return (
      <div className="h-[146px] flex flex-col justify-end gap-4">
        <SkeletonElement className="h-12 w-full rounded-button" />
        <SkeletonElement className="h-12 w-full rounded-button" />
      </div>
    );
  }

  return (
    <div className="h-[146px]">
      {authenticated && hubUser?.defiAddress ? (
        <div className="flex h-full flex-col justify-end gap-4">
          <div className="flex items-center justify-between gap-3">
            <div className="flex-1">
              <ProfileWalletData size="48px" />
            </div>
            <div className="flex items-center gap-2 md:hidden">
              <CurrencySelector source="wallet" />
              <NotificationDropdown />
            </div>
          </div>
          <ClaimRewards fullWidth />
        </div>
      ) : (
        <div className="flex flex-col items-start gap-4 rounded-medium bg-[rgba(2,136,209,0.3)] p-4 pb-5">
          <p className="body1 text-cede-text-primary">
            To participate in Trade Campaigns,
            <br />
            please connect your wallet.
          </p>
          <WalletButton size="large" className="w-full" buttonClassName="w-full" />
        </div>
      )}
    </div>
  );
};
